// TO DO: This module is used not just in mx-grid. Move this file to layout folder.
'use strict';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.ObjectPickerFileSelectionTabController', ['$scope', MxObjectPickerFileSelectionTab]);

function MxObjectPickerFileSelectionTab($scope) {
	const vm = this;

	vm.$onInit = function () {
		$scope.$watch(
			function () {
				return (vm.files || []).some(function (file) {
					return file.selected === true && file.id;
				});
			},
			function (newValue) {
				vm.selectButtonDisabled = !newValue;
			}
		);
	};

	vm.select = function () {
		const selectedObjects = vm.getSelectedObjects();

		vm.finishDefer.resolve({
			selectedObjects: selectedObjects,
			files: vm.files,
		});
	};

	vm.cancel = function () {
		vm.finishDefer.reject(mx.noLogCatchMessage('file selection was canceled'));
	};
}
